<template>
  <template
    v-if="moduleData.dashboardIdent"
  >
    <template
      v-if="typeof $options.components[moduleData.dashboardIdent] != 'undefined'"
    >
      <component
          v-bind:is="moduleData.dashboardIdent"
          :structure="moduleData.structure"
      />
    </template>
    <template v-else>
      Neexistuje modul {{moduleData.dashboardIdent}}
    </template>
  </template>
  <template
    v-else
  >
    <dashboard
        :structure="moduleData.structure"
    >
    </dashboard>
  </template>
</template>

<script>
import dashboard from "@/components/general/Dashboard";
import businessUnitOpenStatus from "@/dashboards/businessUnitOpenStatus.vue";
import giftCouponReader from "@/dashboards/giftCouponReader.vue";
export default {
  name: "DashboardModule",
  components: {
    dashboard,
    businessUnitOpenStatus,
    giftCouponReader
  },
  emits: [
    //"update:reloadSignal"
  ],
  props: {
    "ident": String,
    "route": Object,
    "reloadSignal": String,
    "moduleData": Object,
    "returnData": [Object, String, Number],
    "config": [Object],
  },
  data() {
    return {
      //reloadSignalBox: null,
      //reloadSignalList: null
    }
  },
  mounted() {
    if(typeof this.moduleData.structure == "undefined" && typeof this.moduleData.redirect_path != "undefined") {
      this.$router.push(this.moduleData.redirect_path);
    }
  }
};
</script>